export const toggleFavorite = (req)=>{
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req)
    };
    return fetch('/shared/api/toggleFavorite',requestOptions).then((response)=>response.json())
}


